module.exports = __webpack_public_path__ + "img/kh1.e3bc5b48.png";